import axios from 'axios';
import numeral from '../utils/numeral';

interface BankTransferParams {
    fields: any;
    destinationBankCode: any;
    country: any;
    voucherId?: any;
    isTestGroup?: boolean;
}

export function createBankTransfer({
    fields,
    destinationBankCode,
    country,
    voucherId = null,
    isTestGroup = false
}: BankTransferParams) {
    return axios.post('/api/bank-transfers', {
        ...fields,
        amount: numeral(fields.amount).value().toFixed(2),
        bank: destinationBankCode,
        voucher_id: voucherId,
        country,
        invoice_number: destinationBankCode === 'PC' ? `${fields.invoice_number}-${new Date().getTime()}` : fields.invoice_number,
        isTestGroup: isTestGroup
    });
}